export default __webpack_public_path__ + "static/media/sketch-asian-tn.66b7eb37.png";